import React, { useEffect, useState } from "react";
import MyLibrary from "../../../components/MyLibrary/MyLibrary";
import MobileHeader from "../../../components/MobileHeader/MobileHeader";
import { useAppDispatch, useAppSelector } from "../../../redux/app/hooks";
import { visibility } from "../../../redux/slices/rightSideAd";
import images from "../../../assets/images";
import { useLocation, useNavigate } from "react-router-dom";
import { getScreenDimensions } from "../../../utils/helper";
import "./AdminMaterialsList.scss";
import { GET_CLASSROOM_BY_ID } from "../../AdminClassroom/api/AdminClassroomQuery";
import { classroomByIdDetailsType } from "../../AdminClassroom/AdminClassroom";
import { useLazyQuery } from "@apollo/client";
import Loader from "../../../components/Loader/Loader";

const AdminMaterialsList = () => {
  const dispatch = useAppDispatch();

  dispatch(visibility({ isVisible: true }));
  const { backArrow, bookIcon } = images;
  const navigate = useNavigate();
  const { state } = useLocation();
  const [classroomByIdDetails, setClassroomByIdDetails] =
    useState<classroomByIdDetailsType>();
  const selectedClassroomId = useAppSelector(
    (state) => state.CommonUpload.classroomId
  );

  const [getClassroomById, { loading }] = useLazyQuery(GET_CLASSROOM_BY_ID, {
    fetchPolicy: "no-cache",
    onCompleted: (data) => {
      setClassroomByIdDetails(data?.classroomByCId);
    },
  });

  useEffect(() => {
    getClassroomById({
      variables: {
        cId: selectedClassroomId,
      },
    });
  }, [selectedClassroomId]);

  return (
    <>
      {loading ? (
        <Loader bottom="150px" />
      ) : (
        <div className="admin-materials-upload">
          <div className="materials-header">
            <div className="title-div">
              <img
                src={backArrow}
                alt="backButton"
                className="adminsettings-backbutton"
                onClick={() => navigate("/admin-materials-upload")}
              />
              <div className="header-div">
                <div className="imageContainer">
                  <img src={bookIcon} alt="userImage" className="imageStyle" />
                </div>
                <div className="header-title-div">
                  <div className="primary">Upload</div>
                  <div className="secondary">
                    {classroomByIdDetails?.cOriginalName}
                  </div>
                </div>
              </div>
            </div>
            {getScreenDimensions()?.isMobileScreen && <MobileHeader />}
          </div>
          <MyLibrary />
        </div>
      )}
    </>
  );
};

export default AdminMaterialsList;
